import { PARA_JWT_ROLES, Role, isParaJwtRole } from '@para/shared/utils/para-roles.util';

/** Dashboard variant for `/progress` (not a URL segment). Admin uses `/progress/admin` instead. */
export type ParaExperience = 'teacher' | 'principal' | 'area' | 'admin';

/** Roles allowed into the PARA shell (`/progress`, `/progress/admin`). */
export const PARA_SHELL_ALLOWED_ROLES: readonly Role[] = PARA_JWT_ROLES;

/** Whether the JWT role may enter any `/progress` route. */
export function isParaShellRole(role: Role | string | undefined): boolean {
	return isParaJwtRole(role);
}

const EXPERIENCE_BY_ROLE: Record<Role, ParaExperience> = {
	[Role.ParaTeacher]: 'teacher',
	[Role.ParaPrincipal]: 'principal',
	[Role.ParaArea]: 'area',
	[Role.ParaAdmin]: 'admin',
};

/** Node type IDs hidden in the org tree by experience (Admin matches principal: full tree). */
const EXCLUDED_NODE_TYPES_BY_EXPERIENCE: Record<ParaExperience, number[]> = {
	teacher: [],
	principal: [],
	area: [9],
	admin: [],
};

export function paraExperienceForRole(role: Role | string | undefined): ParaExperience | null {
	if (!isParaJwtRole(role)) return null;
	if (role === Role.ParaAdmin) return null;
	return EXPERIENCE_BY_ROLE[role];
}

/** Org-tree excludes aligned with {@link paraExperienceForRole}; Admin uses the principal-style tree. */
export function paraExcludedTypeIdsForRole(role: Role | string | undefined): number[] {
	if (role === Role.ParaAdmin) {
		return EXCLUDED_NODE_TYPES_BY_EXPERIENCE.principal;
	}
	const e = paraExperienceForRole(role);
	return e != null ? EXCLUDED_NODE_TYPES_BY_EXPERIENCE[e] : [];
}

export function paraDefaultPathForRole(role: Role | string | undefined): string {
	if (role === Role.ParaAdmin) return '/progress/admin';
	return paraExperienceForRole(role) != null ? '/progress' : '/landing';
}
